/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
    Input,
    Label,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";
import Select from "react-select";
const TSSelect2 = props => {
    const [value, setValue] = useState((props.value != null) ? props.value : '');
    const [label, setLabel] = useState((props.label != null) ? props.label : '');
    const [type, setType] = useState((props.type != null) ? props.type : 'select');
    const [placeholder, setPlaceholder] = useState((props.placeholder != null) ? props.placeholder : '');
    const [icon, setIcon] = useState('');

    const [options, setOptions] = useState((props.options !== "undefined") ? props.options : []);
    const [styles, setStyles] = useState((props.styles !== "undefined") ? props.styles : null);
    const [isRequire, setIsRequire] = useState(props.isRequire);
    const [isDisabled, setIsDisabled] = useState(props.isDisabled);
    const [isClearable, setIsClearable] = useState(props.isClearable);
    const [zIndex, setzIndex] = useState((props.zIndex != null) ? props.zIndex : 'null');
    const [fontSize, setFontSize] = useState((props.fontSize != null) ? props.fontSize : '1.2em');
    const [defaultValue, setDefaultValue] = useState({ label: null, value: null });

  useEffect(() => {

      if (props.options != null) {
          const val = props.options.find(e => e.value == props.value)

          if (val !== undefined)
            setDefaultValue(val);
          else
            setDefaultValue({ label: null, value: null })
      }

  }, [props.value, props.options]);

  function handleChange(e) {
    var val = (e != null ) ? e.value : null;
    if (props.onChange) {
      props.onChange(e);
      setValue(val);
    }
  }

  const isSmall = Boolean(props.small);
  const activeFontSize = props.fontSize || fontSize || (isSmall ? "0.9em" : "14px");
  const defaultHeight = isSmall ? "24px" : "38px";

  const customStyles = {
    container: (base) => ({
      ...base,
      zIndex: zIndex,
      ...(props.styles?.container ? props.styles.container(base) : {}),
    }),
    control: (base, state) => ({
      ...base,
      minHeight: props.minHeight || defaultHeight,
      height: props.height || defaultHeight,
      marginBottom: props.marginBottom !== undefined ? props.marginBottom : "0px",
      borderRadius: 4,
      borderColor: state.isFocused ? "#3b82f6" : "#cbd5e1",
      boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : base.boxShadow,
      "&:hover": {
        borderColor: state.isFocused ? "#3b82f6" : "#94a3b8",
      },
      fontSize: activeFontSize,
      ...(props.styles?.control ? props.styles.control(base, state) : {}),
    }),
    valueContainer: (base) => ({
      ...base,
      height: props.height || defaultHeight,
      padding: isSmall ? "0px 4px" : "2px 8px",
      display: "flex",
      alignItems: "center",
      ...(props.styles?.valueContainer ? props.styles.valueContainer(base) : {}),
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: isSmall ? "1px 2px" : "6px 8px",
      svg: isSmall ? { width: "12px", height: "12px" } : { width: "18px", height: "18px" },
      ...(props.styles?.dropdownIndicator ? props.styles.dropdownIndicator(base) : {}),
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: isSmall ? "1px 2px" : "6px 8px",
      svg: isSmall ? { width: "12px", height: "12px" } : { width: "16px", height: "16px" },
      ...(props.styles?.clearIndicator ? props.styles.clearIndicator(base) : {}),
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: props.height || defaultHeight,
      ...(props.styles?.indicatorsContainer ? props.styles.indicatorsContainer(base) : {}),
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      textAlign: "left",
      fontSize: activeFontSize,
      ...(props.styles?.menu ? props.styles.menu(base) : {}),
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: activeFontSize,
      color: "#1e293b",
      ...(props.styles?.singleValue ? props.styles.singleValue(base) : {}),
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: activeFontSize,
      color: "#94a3b8",
      ...(props.styles?.placeholder ? props.styles.placeholder(base) : {}),
    }),
    option: (base) => ({
      ...base,
      fontSize: activeFontSize,
      padding: isSmall ? "2px 6px" : "6px 12px",
      ...(props.styles?.option ? props.styles.option(base) : {}),
    }),
    input: (base) => ({
      ...base,
      margin: "0px",
      padding: "0px",
      fontSize: activeFontSize,
      ...(props.styles?.input ? props.styles.input(base) : {}),
    }),
    ...(props.styles || {}),
  };

  const labelStyle = {
    fontWeight: 500,
    fontSize: "14px",
    color: "#334155",
    marginBottom: 6,
    display: "inline-block",
    ...(props.labelStyle || {}),
  };

  return (
    <div>
      {label != "" ? <Label style={labelStyle}>{label}</Label> : <></>}
      <Select
        styles={customStyles}
        options={props.options}
        onChange={handleChange}
        value={defaultValue}
        isDisabled={props.isDisabled !== undefined ? props.isDisabled : isDisabled}
        isClearable={isClearable}
        placeholder={props.placeholder || placeholder}
        menuPortalTarget={props.menuPortalTarget}
        menuPosition={props.menuPosition}
        menuPlacement={props.menuPlacement}
        menuShouldScrollIntoView={props.menuShouldScrollIntoView}
        closeMenuOnScroll={props.closeMenuOnScroll}
      />
    </div>
  );
};

export default TSSelect2;
